import { get } from 'lodash'
import { maxLength, lessThan, required } from 'utils/validation'
import { ORGANIZATION_HIERARCHY } from 'constants/enums'

export default (fields = {}, props = {}) => {
  const isIac = ORGANIZATION_HIERARCHY.IAC.id === get(props, 'route.isTypeId')
  let errors = {}

  if (isIac) {
    errors = {
      invoicingName: required(fields.invoicingName),
      exchequerNumber: maxLength(6)(fields.exchequerNumber),
      // vatNumber: maxLength(15)(fields.vatNumber) ||
      //   checkRegex(fields.vatNumber, /^[a-z0-9]+$/i),
      gnippPercentage: lessThan(500)(fields.gnippPercentage)
    }
  }

  return errors
}
